import { useTranslation } from 'react-i18next'

interface TeamMember {
  nameKey: string
  roleKey: string
  photo?: string
  initials?: string
}

const teamMembers: TeamMember[] = [
  {
    nameKey: 'landing.team.members.mike.name',
    roleKey: 'landing.team.members.mike.role',
    photo: '/images/mike.jpg',
  },
  {
    nameKey: 'landing.team.members.luna.name',
    roleKey: 'landing.team.members.luna.role',
    photo: '/images/luna.jpg',
  },
  {
    nameKey: 'landing.team.members.oleg.name',
    roleKey: 'landing.team.members.oleg.role',
    photo: '/images/oleg.jpg',
  },
]

export function Team() {
  const { t } = useTranslation()

  return (
    <section className="team" id="team">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{t('landing.team.title')}</h2>
          <p className="section-subtitle">{t('landing.team.subtitle')}</p>
        </div>
        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <div key={index} className="team-card">
              <div className="team-photo">
                {member.photo ? (
                  <img src={member.photo} alt={t(member.nameKey)} />
                ) : (
                  <span>{member.initials || t(member.nameKey).charAt(0)}</span>
                )}
              </div>
              <h3>{t(member.nameKey)}</h3>
              <p>{t(member.roleKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
